import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { FC } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router'

type Props = {
  title: string
  createPath: string
}

export const ReleaseHeader: FC<Props> = ({ title, createPath }) => {
  const { t } = useTranslate()
  const navigate = useNavigate()

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Header
        title={title}
        position='relative'
        rightRenderOption={
          <Button
            sx={{ flex: 'none' }}
            variant='contained'
            onClick={() => navigate(createPath)}
            data-cy='create-numeric-release'
          >
            {t('createRelease', 'Create release')}
          </Button>
        }
      />
    </>
  )
}
